export enum MentorSessionFreePayment {
	Payment_Free = 'free',
	payment_duration = 10
}